/* eslint-disable @atlaskit/design-system/no-styled-tagged-template-expression */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from 'styled-components';

import { h200 } from '@atlaskit/theme/typography';
import { token } from '@atlaskit/tokens';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const AboutContent = styled.div``;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const EmptyState = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;

	width: 200px;
	margin: ${token('space.500', '40px')} auto ${token('space.200', '16px')};
	text-align: center;

	p {
		margin-top: ${token('space.400', '32px')};
	}
`;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const AboutSectionTitle = styled.h2`
	${h200};
	margin-top: ${token('space.300', '24px')};
	margin-bottom: ${token('space.200', '16px')};
	text-transform: uppercase;
	letter-spacing: normal;
`;

// TODO Delete this comment after verifying spacing token -> previous value `margin-bottom: 4px`
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const AboutItemList = styled.div`
	> :not(:last-child) {
		margin-bottom: ${token('space.050', '4px')};
	}
`;
